import React, { memo, VFC, useState, useEffect, useCallback } from 'react';
import {
  Center,Spinner,Text,Divider,
  Table,Thead,Tbody,Tr,Th,Td,Flex,Box
} from '@chakra-ui/react';
import { ListButton } from '../atoms/button/ListButton';
import { ListSfdcButton } from '../atoms/button/ListSfdcButton';
import { SearchInput } from '../atoms/input/SearchInput';
import { ErrorDialog } from '../organisms/modal/ErrorDialog';
import { useIssue } from '../../hooks/useIssue';
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";
import { CaseDetailDialog } from '../organisms/modal/CaseDetailDialog';
import { IssueGroupDetailDialog } from '../organisms/modal/IssueGroupDetailDialog';
import { caseObj, groupNameObj, searchParam } from '../../types/issue';
import { useOpelog } from '../../hooks/useOpelog';
import { GV_DESKS } from '../../hooks/useConst';

type Props = {
  setDTStr: (dt:string)=>void;
};

export const CaseTable: VFC<Props> = memo((props) => {
  const { setDTStr } = props;
  const { loginUser } = useLoginUser();
  const [ caseList, setcaseList ] = useState<Array<caseObj>>([]);
  const { getCaseListResult, getCaseList, executing, errObj } = useIssue();
  const [ searchParam, setSearchParam ] = useState<searchParam>({
    username: '',
    userGroup: '',
    fromDate: '',
    toDate: '',
    buName: '',
    custName: '',
    blankFlag: false,
    cloud_type: '',
    noticeKind: '',
    eval_key: {},
  });
  const [ execFlag, setExecFlag ] = useState(false);
  const { OutputOpelog } = useOpelog();
  const [ closeFlag, setCloseFlag ] = useState(false);

  // API実行準備
  useEffect(() => {
    setExecFlag(true);
    // eslint-disable-next-line 
  }, []);
  
  // API実行準備
  useEffect(() => {
    if( execFlag && searchParam.fromDate && searchParam.toDate ){
      setExecFlag(false);
      getCaseList(searchParam);
      OutputOpelog( 'case_list', 'reference', '');
    }
  }, [execFlag, searchParam]);

  // 検索実行
  const execSearch = useCallback(() => {
    getCaseList(searchParam);
    
  }, [searchParam]);
    
  useEffect(() => {
    if( getCaseListResult !== null ){
      setDTStr(`（検索時刻：${getCaseListResult.get_data_time} ）`);
      setcaseList([...getCaseListResult.case_list]
        .sort((a,b)=>{
          if( a.last_modified_date < b.last_modified_date ) return 1;
          if( a.last_modified_date > b.last_modified_date ) return -1;
          return 0;
        }));
    }
  }, [getCaseListResult,setDTStr]);
  
  return (
    <>
      {errObj && !closeFlag ? (
        <ErrorDialog errTitle="問い合わせ履歴" errObj={errObj} opeErrMes="" setCloseFlag={setCloseFlag} />
      ) : (
        <>
          <SearchInput
            func='case'
            searchParam={searchParam}
            setSearchParam={setSearchParam}
            defaultSearchDays={loginUser.case_search_days}
            maxSearchDays={loginUser.max_case_search_days}
            cloud_list={loginUser.mailgroup_cloud_list}
            executing={executing}
            execSearch={execSearch}
          />
          <Divider orientation="horizontal" mt="10px" />
          {/* 以下リスト */}
          {executing ? (
            <Center h="20vh">
              <Spinner color="teal.500" />
            </Center>
          ) : (
            <CaseTableSub caseList={caseList} />
          )}
        </>
      )}
    </>
  );
});

type PropsSub = {
  caseList: caseObj[]; 
};

export const CaseTableSub: VFC<PropsSub> = memo((props) => {
  const { caseList } = props;
  const { loginUser } = useLoginUser();
  const [ userGroup ] = useState(loginUser.userGroup);
  const [ groupName, setGroupName ] = useState('');
  const [ caseId, setCaseId ] = useState('');
  
  const show_summary_button = (group_name: string, risk_flag: number) => {

    let show_summary = true;
    if( risk_flag === 1) {
      if ( userGroup === 'exec' ) {
        show_summary = false;
      }
    }

    if (show_summary) {
      return <ListButton onClick={()=>setGroupName(group_name)}>詳細</ListButton>
    } else {
      return <Box />
    }
  };

  return (
    <>
      <Box id="case">
        <Flex alignItems="flex-end">
          <Text fontSize="lg">
            ■問い合わせ一覧（{caseList.length}件）
          </Text>
        </Flex>
        <Text color="black" align="left">※障害影響がある場合に、障害有無の欄に〇が付きます。</Text>
        <Text color="tomato" align="left">※障害有無、障害グループは、問い合わせと障害の関係可能性を示す参考情報であり、最終的な判断は各プロジェクトでお願いします。</Text>
        {/* 以下障害グループ詳細リスト */}
        <Table id="table-health-group-detail" border="1" colorScheme="gray" variant="striped" size="sm">
          <Thead background="#aaaaaa">
            <Tr>
            <Th color="white" fontSize="sm">No.</Th>
            <Th color="white" fontSize="sm">更新日時</Th>
            <Th color="white" fontSize="sm">アカウントID</Th>
            <Th color="white" fontSize="sm">お客様名</Th>
            <Th color="white" fontSize="sm">タイトル</Th>
            <Th color="white" fontSize="sm">詳細</Th>
            <Th color="white" fontSize="md">障害有無</Th>
            <Th color="white" fontSize="sm">障害グループ</Th>
          </Tr>
          </Thead>
          <Tbody>
            {caseList.map((item:caseObj,index) => (
              <Tr key={index}>
                <Td>{index+1}</Td>
                <Td>{item.last_modified_date}</Td>
                <Td>{item.linked_account}</Td>
                <Td>{item.end_user}</Td>
                <Td>{item.subject}</Td>
                <Td align="center">
                  <Flex gap='2'>
                    <ListButton onClick={()=>setCaseId(item.custom_obj_id)}>詳細</ListButton>
                    {GV_DESKS.includes(loginUser.userGroup) &&
                      <ListSfdcButton customObjId={item.custom_obj_id}>SFDC</ListSfdcButton>
                    }
                  </Flex>
                </Td>
                <Td>{item.fail_link}</Td>
                <Td>
                {item.group_name_list.map((group_item:groupNameObj) => (
                  <Flex key={group_item.group_name} alignItems="center">
                    <Text>{group_item.group_name}</Text>
                    {show_summary_button(group_item.group_name, group_item.risk_flag)}
                  </Flex>
                ))}
                </Td>

              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
      {groupName !== '' && (
        <IssueGroupDetailDialog groupName={groupName} setGroupName={setGroupName} />
      )}
      {caseId !== '' && (
        <CaseDetailDialog caseId={caseId} setCaseId={setCaseId} />
      )}
    </>
  );
});


type PropsGroup = {
  caseList: caseObj[]; 
};

export const CaseTableGroup: VFC<PropsGroup> = memo((props) => {
  const { caseList } = props;
  const { loginUser } = useLoginUser();
  const [ caseId, setCaseId ] = useState('');

  return (
    <>
      <Box id="case">
        <Flex alignItems="flex-end">
          <Text fontSize="lg">
            ■問い合わせ一覧（{caseList.length}件）
          </Text>
        </Flex>
        {/* 以下障害グループ詳細リスト */}
        <Table id="table-health-group-detail" border="1" colorScheme="gray" variant="striped" size="sm">
          <Thead background="#aaaaaa">
            <Tr>
            <Th color="white" fontSize="sm">No.</Th>
            <Th color="white" fontSize="sm">更新日時</Th>
            <Th color="white" fontSize="sm">状況</Th>
            <Th color="white" fontSize="sm">サブ状況</Th>
            <Th color="white" fontSize="sm">お客様名</Th>
            <Th color="white" fontSize="sm">タイトル</Th>
            <Th color="white" fontSize="sm">アカウントID</Th>
            <Th color="white" fontSize="sm"></Th>
          </Tr>
          </Thead>
          <Tbody>
            {caseList.map((item:caseObj,index) => (
              <Tr key={index}>
                <Td>{index+1}</Td>
                <Td>{item.last_modified_date}</Td>
                <Td>{item.status}</Td>
                <Td>{item.sub_status}</Td>
                <Td>{item.end_user}</Td>
                <Td>{item.subject}</Td>
                <Td>{item.linked_account}</Td>
                <Td align="center">
                  <Flex gap='2'>
                    <ListButton onClick={()=>setCaseId(item.custom_obj_id)}>詳細</ListButton>
                    {GV_DESKS.includes(loginUser.userGroup) &&
                      <ListSfdcButton customObjId={item.custom_obj_id}>SFDC</ListSfdcButton>
                    }
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
      {caseId !== '' && (
        <CaseDetailDialog caseId={caseId} setCaseId={setCaseId} />
      )}
    </>
  );
});
